import { SET_DEVICE_INFO, CLEAR_DEVICE_INFO } from "../types";

const initialState = {
    device: null
};

const deviceReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_DEVICE_INFO:
            return {
                ...state,
                device: action.payload
            };
        case CLEAR_DEVICE_INFO:
            return {
                ...state,
                device: null
            };
        default:
            return state;
    }
};

export default deviceReducer;
